import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { IMandrillEmail } from "./mandrillEmail.types"
import { MandrillEmail } from "./mandrillEmail"
import { MandrillSearchResult } from "@/api/backofficeRest/generated/model"

export type MandrillEmailRaw = MandrillSearchResult

export const MandrillEmailParser: IParser<IMandrillEmail, MandrillEmailRaw> = {
  toDomain: (data: MandrillEmailRaw) => {
    try {
      return new MandrillEmail(
        dayjs(data.emailSentDate),
        data.opens,
        data.sender,
        data.status ?? null,
        data.subject,
        data.clicks,
        data.bounceDetail ?? null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
